import { Predicate } from "@siteimprove/alfa-predicate";
import { Role } from "../../role.js";
const { equals, property } = Predicate;
export function hasExplicitRole(nameOrPredicate = () => true, ...names) {
    let predicate;
    if (typeof nameOrPredicate === "function") {
        predicate = nameOrPredicate;
    }
    else {
        predicate = property("name", equals(nameOrPredicate, ...names));
    }
    return (element) => Role.fromExplicit(element).some(predicate);
}
//# sourceMappingURL=has-explicit-role.js.map